import React, { useCallback } from 'react';
import $ from 'jquery';

const getNextActiveElement = (activeElement, direction) => {
  if (activeElement.is('button')) {
    const parentOption = activeElement.parentsUntil('[role=option],[role=heading]');
    const buttons = parentOption.find('button:not([disabled])');
    const activeIndex = buttons.index(activeElement);
    const nextIndex = activeIndex + direction;
    if (nextIndex >= 0 && nextIndex < buttons.length) {
      return buttons.eq(nextIndex);
    }
    return activeElement;
  }
  return activeElement.find('button:not([disabled])').eq(0);
};

export const InputSlot = (Component, passedProps) => {
  const originKeyDown = passedProps.onKeyDown;
  const inputEle = $('[role=listbox]').parent().find('input');
  const onInputKeyDown = useCallback((e) => {
    if (passedProps['aria-expanded']) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        const currentActiveEle = $('[role=listbox] [data-activedescendant-focusvisible]');
        const nextActiveElement = getNextActiveElement(currentActiveEle, e.key === 'ArrowRight' ? 1 : -1);
        if (nextActiveElement.length !== 0) {
          currentActiveEle.removeAttr('data-activedescendant-focusvisible');
          nextActiveElement.attr('data-activedescendant-focusvisible', true);
          inputEle.attr('aria-activedescendant', nextActiveElement.attr('id'));
        }
        e.preventDefault();
        e.stopPropagation();
        return;
      } else if (e.key === 'Enter' || e.key === ' ') {
        const activeID = inputEle.attr('aria-activedescendant');
        const activeElement = $(`#${activeID}`);
        if (activeElement.is('button')) {
          activeElement.trigger('click');
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }
      $('[role=listbox] button[data-activedescendant-focusvisible]').removeAttr('data-activedescendant-focusvisible');
      originKeyDown(e);
    } else {
      originKeyDown(e);
    }
  }, [inputEle, originKeyDown, passedProps]);
  return <Component {...passedProps} onKeyDown={onInputKeyDown} />;
};
